import React from 'react';
import { BrowserRouter as Router, Navigate, Route, Routes } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { makeStyles, MuiThemeProvider } from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';
import Header from './components/shared/header/Header.js';
import LoadingModal from './components/shared/loadingmodal/LoadingModal.js';
import GlobalDialogMessage from './components/shared/dialogmessage/GlobalDialogMessage.js';
import WrappedRoutes from './components/WrappedRoutes.jsx';
import { BASE_NAME, PROJECT_NAME } from './constants/index.js';
import useErrorMessage from './hooks/useErrorMessage.js';
import Message from './components/shared/message/Message.js';
import PageWrapper from './components/shared/pagewrapper/PageWrapper.js';
import ShowInDesktop from './components/shared/responsive/ShowInDesktop.js';
import ShowInMobile from './components/shared/responsive/ShowInMobile.js';
import Separator from './components/shared/separator/Separator.js';
import theme from './theme/theme.js';

// Roda fora do MuiThemeProvider: lê o tema importado, não o do makeStyles (que seria o padrão do MUI).
const useStyles = propsStyle => makeStyles(() => ({
    '@global': {
        'html, body, #root': {
            height: '100%',
            '-webkit-overflow-scrolling': 'touch',
        },
        body: {
            // Fundo sólido conforme solicitado ("nao qero nenhuma imagem")
            background: propsStyle.transparentBackground ? 'transparent' : theme.palette.background.default,
            backgroundAttachment: 'fixed'
        },
        'ul, ol': {
            margin: 0,
            padding: 0,
            listStyle: 'none'
        },
        a: {
            textDecoration: 'underline'
        },
        p: {
            marginTop: 0
        },
        '#root': {
            height: '100%'
        }
    },
    gridContainer: {
        minHeight: '100%',
        display: 'grid',
        gridTemplateRows: 'min-content 1fr min-content',
        // Coluna limitada à largura da tela: conteúdo largo (abas, tabelas) rola dentro dele em vez de alargar a página.
        gridTemplateColumns: 'minmax(0, 1fr)'
    },
}));

export default function App() {
    const propsStyle = {
        transparentBackground: useSelector(state => state.embedded)
    };
    const embedded = useSelector(state => state.embedded);
    const classes = useStyles(propsStyle)();
    const showHeader = useSelector(state => state.showHeader);
    useErrorMessage();

    return (
        <Router basename={BASE_NAME}>
            <>
                <CssBaseline />
                <MuiThemeProvider theme={theme}>
                    <LoadingModal />
                    <GlobalDialogMessage />
                    <div className={classes.gridContainer}>
                        {!embedded && showHeader && (
                            <Header
                                title={PROJECT_NAME}
                                subtitle='Portal Unaerp' />
                        )}
                        <main>
                            <WrappedRoutes />
                        </main>
                    </div>
                </MuiThemeProvider>
            </>
        </Router>
    );
}
